import { ROLES } from '../config/Constants'

export default (level, role) => {
    const isSapExecutive = Boolean(localStorage.getItem('isSapExecutive'))
    const isShiftManager = Boolean(localStorage.getItem('isShiftManager'))
    const isChiefMachinery = Boolean(localStorage.getItem('isChiefMachinery'))
    if (level === 1 && (role === ROLES.SHIFT_MANAGER || isShiftManager)) {
        return true
    } else if (level === 2 && (role === ROLES.CHIEF_MACHINERY || isChiefMachinery)) {
        return true
    } else if (level === 3 && (role === ROLES.SAP_EXECUTIVE || role === ROLES.ADMIN || isSapExecutive)) {
        return true
    } else {
        return false
    }
}
